import React from 'react';
import {
  Filter, TextInput,
} from 'react-admin';

const MetaFilter = props => (
  <Filter {...props}>
    <TextInput label="Search by title" source="q" alwaysOn />
  </Filter>
);

export default MetaFilter;
